import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.plugins.unregister(ChartDataLabels);
Chart.plugins.register(ChartDataLabels);

Chart.defaults.global.plugins.datalabels = {
    anchor: 'end',
    align: 'top',
    offset: 4,
    clamp: true,
    color: 'rgb(25 118 210)',
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: 4,
    padding: {
        top: 4,
        bottom: 4,
        left: 6,
        right: 6
    },
    font: {
        weight: 'bold',
        size: 10
    },
    // display: function(context) {
    //     return context.dataset.data[context.dataIndex] > 0;
    // },
    formatter: function(value) {
        if (typeof value === 'number') {
            return value.toLocaleString();
        }
        return value;
    }
};

Chart.defaults.global.scales = {};

Chart.defaults.bar.scales = {
    xAxes: [
        {
            gridLines: {
                display: false
            },
            ticks: {
                fontSize: 10,
                padding: 8
            }
        }
    ]
};

Chart.defaults.global.layout = {
    padding: {
        top: 25,
        left: 0
    }
};

export default {
    install(Vue) {
        Vue.prototype.$Chart = Chart;
    }
};
